import React from 'react';

export default function About() {
  return (
    <div className='container mt-5'>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quam mollitia error obcaecati numquam dolorum nulla
        iure incidunt neque sequi vero cumque, optio, accusantium ea ut beatae repellendus tempora. Quae, temporibus
      </p>

      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quam mollitia error obcaecati numquam dolorum nulla
        iure incidunt neque sequi vero cumque, optio, accusantium ea ut beatae repellendus tempora. Quae, temporibus
      </p>

      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quam mollitia error obcaecati numquam dolorum nulla
        iure incidunt neque sequi vero cumque, optio, accusantium ea ut beatae repellendus tempora. Quae, temporibus
      </p>
    </div>
  );
}
